import { gql } from '@apollo/client'

export const EMPLOYEE_LOGIN = gql`
    mutation employeeLogin($generate: BaseInput!) {
        employeeLoginMutation(generate: $generate) {
            token
        }
    }
`

export const EMPLOYEE_LOGIN_WITH_PROVIDER = gql`
    mutation employeeLoginByAd($input: SessionInputAd!) {
        employeeLoginByAd(input: $input) {
            token
        }
    }
`

export const GENERATE_PASSWORD = gql`
    mutation generatePassword($generate: GeneratePasswordInput!) {
        generatePassword(generate: $generate) {
            id
        }
    }
`

export const UPDATE_EMPLOYEE_NICKNAME = gql`
    mutation updateEmployeeNickname($data: EmployeeNicknameInput!) {
        updateEmployeeNickname(data: $data) {
            nickname
        }
    }
`
